import { Grid, Typography } from '@mui/material';
import { ServiceAgreementDetailResponse } from 'ogp/services/service-agreements.types';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';

export const ServiceAgreementInfo = ({ data }: { data: ServiceAgreementDetailResponse }) => {
  const { t } = useTranslation(['ogp-screen-specific', 'all-platforms-common']);
  const otherCompanyRoleTranslation =
    data.serviceAgreementPartyRole === 'BORROWER'
      ? t('service-agreement.lender', { ns: 'all-platforms-common' })
      : t('service-agreement.borrower', { ns: 'all-platforms-common' });
  const otherCompanyName =
    data.serviceAgreementPartyRole === 'BORROWER'
      ? data.lenderServiceAgreementParty.name
      : data.borrowerServiceAgreementParty.name;

  return (
    <Grid item container spacing={3} xs={8}>
      <Grid item xs={6}>
        <Typography variant="subtitle1">{otherCompanyRoleTranslation}</Typography>
        <Typography variant="body2">{otherCompanyName}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle1">
          {t('service-agreement.worker_pool_size', { ns: 'ogp-screen-specific' })}
        </Typography>
        <Typography variant="body2">{data.workerPoolSize}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle1">
          {t('service-agreement.start_date', { ns: 'ogp-screen-specific' })}
        </Typography>
        <Typography variant="body2">{DateTime.now().toFormat('yyyy-MM-dd')}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle1">
          {t('service-agreement.flexpool_count', { ns: 'ogp-screen-specific' })}
        </Typography>
        <Typography variant="body2">{data.flexPoolCount}</Typography>
      </Grid>
    </Grid>
  );
};
